export const dateFormatter = (date: Date): string => {
  const dateArray = date.toString().split(' ');
  return `${dateArray[3]}-${getMonthFromString(dateArray[1])}-${dateArray[2]} ${dateArray[4]}`;
};

const getMonthFromString = (month: string): string => {
  const monthNumber = new Date(Date.parse(month + ' 1')).getMonth() + 1;
  return ('0' + monthNumber).slice(-2);
};
